import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import '@styles/components/tooltip.css'

export default {
  init: () => {
    tippy('[data-tooltip]', {
      content: (ref) => {
        return document.getElementById(ref.getAttribute('aria-describedby')).textContent
      },
    })
  },
}
